import React from 'react';
import DayPickerSingleDateController from 'react-dates/lib/components/DayPickerSingleDateController';
import { Moment } from 'moment';

type Props = {
  onDateChange: Function;
  daySize?: number;
  selectedDay?: Moment;
  isOutsideRange?: Function;
  enableOutsideDays?: boolean;
};

const WpCalendarPicker = ({
  selectedDay = null,
  onDateChange,
  daySize,
  isOutsideRange = () => false,
  enableOutsideDays = false,
}: Props) => {
  return (
    <DayPickerSingleDateController
      daySize={daySize}
      transitionDuration={0}
      keepOpenOnDateSelect={false}
      hideKeyboardShortcutsPanel
      numberOfMonths={1}
      date={selectedDay}
      onDateChange={onDateChange}
      focused
      onFocusChange={() => false}
      noBorder
      enableOutsideDays={enableOutsideDays}
      isOutsideRange={isOutsideRange}
    />
  );
};

export default WpCalendarPicker;
